import { Box, Typography } from '@mui/material';
import React, { useContext } from 'react'
import Bid from '../../components/Quote/Bid';
import Ask from '../../components/Quote/Ask';
import { ThemeContext } from '../../../context/ThemeContext';

export default function SimpleDetailedView({ symbol, handleQuoteClick }) {
    const { darkMode } = useContext(ThemeContext)

    return (
        <>
            <Box sx={{ p: 1, display: "flex", justifyContent: "space-between" }} onClick={() => handleQuoteClick(symbol)}>
                <Box sx={{ backgroundColor: darkMode ? "#151924" : 'var(--white)' }}>
                    <Typography variant="body1" fontWeight="bold" sx={{ color: darkMode ? "var(--white)" : 'var(--black)', margin: 0 }}>{symbol?.name}</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                    <Box><Bid symbolId={symbol?.id} /></Box>
                    <Box sx={{ marginLeft: 2 }}><Ask symbolId={symbol?.id} /></Box>
                </Box>
            </Box>
        </>
    );

}
